module.exports = __webpack_public_path__ + "public/images/scientist.9a5cda9046eb066a8e1a9e2dd4b11afd.webp";